import { adminOrders, ordersTable } from "../parts";
import type { OrderStatus } from "../types";
import { figures, h, money, show } from "../ui";

const STATUSES: ("all" | OrderStatus)[] = ["all", "paid", "manual", "pending", "expired", "refunded"];

export async function ordersPage() {
  const ord = await adminOrders({ limit: 200 });
  if (!ord) return;
  const orders = ord.orders;
  let status = "all";
  const holder = h("div");
  const count = (s: string) => orders.filter((o) => o.status === s).length;
  const sum = (s: string) => orders.filter((o) => o.status === s).reduce((t, o) => t + o.amount - o.refunded_amount, 0) / 100;
  const tabs = h(
    "div",
    { class: "periods", role: "group", "aria-label": "Status" },
    ...STATUSES.map((s) => {
      const b = h("button", { type: "button", "aria-pressed": String(s === status) }, s === "all" ? "All" : s[0]!.toUpperCase() + s.slice(1)) as HTMLButtonElement;
      b.addEventListener("click", () => {
        status = s;
        for (const x of tabs.querySelectorAll("button")) x.setAttribute("aria-pressed", String(x === b));
        draw();
      });
      return b;
    }),
  );
  const draw = () => holder.replaceChildren(ordersTable(status === "all" ? orders : orders.filter((o) => o.status === status)));
  show(
    "Orders",
    "Plans bought through Luwu Pay and plans granted by staff (manual), newest first. Prices: Basic $5 / $50, Pro $15 / $150, Team $80 / $800 for 5 seats (luwu.dev/pricing).",
    figures([
      ["Paid", money(sum("paid")), `${count("paid")} orders`],
      ["Granted", `${count("manual")}`, "by staff, no payment"],
      ["Pending", money(sum("pending")), `${count("pending")} orders`],
      ["Expired", money(sum("expired")), `${count("expired")} orders`],
      ["Refunded", money(orders.filter((o) => o.refunded_amount > 0).reduce((t, o) => t + o.refunded_amount, 0) / 100), `${count("refunded")} orders`],
      ["Revenue, 30 days", money(ord.last30d.revenue / 100), `${ord.last30d.orders} orders`],
    ]),
    h("div", { class: "listbar" }, h("h2", null, "All orders"), tabs),
    holder,
  );
  draw();
}
